"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const network_1 = require("@dcl/schemas/dist/dapps/network");
const BuyManaWithFiatModal_1 = require("decentraland-ui/dist/components/BuyManaWithFiatModal/BuyManaWithFiatModal");
const Network_1 = require("decentraland-ui/dist/components/BuyManaWithFiatModal/Network");
const utils_1 = require("../../modules/translation/utils");
const utils_2 = require("../../modules/analytics/utils");
class BuyManaWithFiatModal extends React.PureComponent {
    constructor(props) {
        super(props);
        this.analytics = (0, utils_2.getAnalytics)();
        this.getDefaultModalTranslations = () => {
            return this.getDefaultTranslations('@dapps.buyManaWithFiat.modal', [
                'title',
                'subtitle',
                'error'
            ]);
        };
        this.getDefaultNetworkTranslations = (network) => {
            return this.getDefaultTranslations(`@dapps.buyManaWithFiat.network.${network.toLowerCase()}`, ['cta', 'ctaSubtitle', 'title', 'error']);
        };
        this.getDefaultGatewayTranslations = (network, gateway) => {
            return this.getDefaultTranslations(`@dapps.buyManaWithFiat.network.${network.toLowerCase()}.${gateway}`, ['title', 'subtitle', 'continueButtonText', 'learnMoreText']);
        };
        this.state = {
            hasError: false
        };
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.hasError && this.props.hasError) {
            this.setState({
                hasError: true
            });
        }
        else if (prevProps.hasError && !this.props.hasError) {
            this.setState({
                hasError: false
            });
        }
    }
    getDefaultTranslations(basePath, props) {
        if (!this.props.hasTranslations) {
            return undefined;
        }
        return Object.fromEntries(props.map(it => [it, (0, utils_1.t)(`${basePath}.${it}`)]));
    }
    getDefaultNetworks() {
        const networks = [network_1.Network.MATIC, network_1.Network.ETHEREUM];
        const gateways = [Network_1.NetworkGatewayType.MOON_PAY, Network_1.NetworkGatewayType.TRANSAK];
        const gatewayLearnMoreLink = {
            [Network_1.NetworkGatewayType.MOON_PAY]: 'https://www.moonpay.com/',
            [Network_1.NetworkGatewayType.TRANSAK]: 'https://transak.com/'
        };
        const isDisabled = (network, gateway) => network === network_1.Network.MATIC && gateway === Network_1.NetworkGatewayType.MOON_PAY;
        return networks.map(network => ({
            type: network,
            i18n: this.getDefaultNetworkTranslations(network),
            gateways: gateways
                .filter(gateway => !isDisabled(network, gateway))
                .map(gateway => ({
                type: gateway,
                i18n: this.getDefaultGatewayTranslations(network, gateway),
                learnMoreLink: gatewayLearnMoreLink[gateway],
                onContinue: () => this.handleOnContinue(network, gateway)
            })),
            onClick: () => this.handleNetworkOnClick(network)
        }));
    }
    handleOnContinue(network, gateway) {
        this.analytics.track('Choose Gateway', { network, gateway });
        this.props.onContinue(network, gateway);
        this.props.onClose();
    }
    handleNetworkOnClick(network) {
        this.analytics.track('Choose Network', { network });
    }
    render() {
        const { i18n, className, isLoading, metadata, onClose, onInfo } = this.props;
        const { hasError } = this.state;
        const networks = this.props.networks || this.getDefaultNetworks();
        return (React.createElement(BuyManaWithFiatModal_1.BuyManaWithFiatModal, { open: true, className: className, i18n: i18n || this.getDefaultModalTranslations(), networks: (metadata === null || metadata === void 0 ? void 0 : metadata.selectedNetwork)
                ? networks.filter(network => network.type === metadata.selectedNetwork)
                : networks, loading: isLoading, hasError: hasError, onClose: onClose, onInfo: onInfo }));
    }
}
exports.default = BuyManaWithFiatModal;
BuyManaWithFiatModal.defaultProps = {
    isLoading: false
};
//# sourceMappingURL=BuyManaWithFiatModal.js.map